import Pqp from "../3x1010/Pqp.js";
//import Sounder from "./Tools/sounder/Sounder";
import MainLoop from "./Tools/MainLoop";
import Spran from "./Tools/spran/Spran";
import Controls from "./Tools/controls/Controls";
import Game from "./Game.js";
import Sprites from "./Tools/Sprites.js";
import Main from "./Main.js";
import Sounder from "../3x1010/sounder/Sounder.js";

export default class ScreenGameOver {
  constructor(data, callback) {
    this.data = data;
    this.callback = callback;
    this.tick = 0;
  }

  init() {
    //console.log(this.data);
    this.mc = jQuery("#template-gameover-screen").clone();
    this.mc.removeAttr("id");
    jQuery(".js-main").append(this.mc);
    //Sounder.play("smallloop", null, true);
    Main.that.sounder.playLoop("smallloop");
    this.initListeners();
    let savegame = Main.savegame;
    let a = savegame.data;
    let all = true;
    for (let x = 0; x < a.length; x++) {
      if (a[x].won === 0) {
        all = false;
        break;
      }
    }
    if (all) {
      this.createScenetteOk()
    } else {
      this.createScenetteKo()
    }

    if (Pqp.isMobile()) {
      jQuery(".do-tap", this.mc).show();
      jQuery(".do-click", this.mc).hide();
    } else {
      jQuery(".do-tap", this.mc).hide();
      jQuery(".do-click", this.mc).show();
    }

  }


  initListeners() {
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    jQuery(window).on("blur", this.onMinimize.bind(this));
    jQuery(window).on("focus", this.onMaximize.bind(this));
  }

  onMinimize() {
    TweenMax.pauseAll();
    //Sounder.pauseAll();
    Main.that.sounder.pause("smallloop");
    Main.that.sounder.pause("ending");
    MainLoop.pause();
  }

  onMaximize() {
    TweenMax.resumeAll();
    //Sounder.resumeAll();
    Main.that.sounder.resume("smallloop");
    Main.that.sounder.resume("ending");
    MainLoop.resume();
  }

  destroy() {
    this.mc.off("click");
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    //Sounder.stop("smallloop");
    Main.that.sounder.stop("smallloop");
    MainLoop.unsubscribe(this);
    MainLoop.unsubscribe(this.cornholio);
    if (this.sorry) {
      MainLoop.unsubscribe(this.sorry);
    }
    if (this.princess) {
      MainLoop.unsubscribe(this.princess);
    }
    if (this.karateka) {
      MainLoop.unsubscribe(this.karateka);
    }
    MainLoop.stop();
    this.mc.remove();
  }

  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }


  createScenetteKo() {
    let sp;
    sp = Sprites.getSpriteByRowCol("floor", 0, 0);
    jQuery(".js-floor", this.mc).css("background-image", "url('" + sp + "')");

    jQuery(".js-main").removeClass("blue");
    jQuery(".js-main").addClass("black");

    MainLoop.start();
    this.createCornholio("run");
    this.createSorry();

    MainLoop.start();
    TweenMax.to(jQuery(".js-cornholiio", this.mc), 1.5, { left: "25%", onComplete: this.makeSpeech.bind(this), ease: Linear.easeNone });
  }


  makeSpeech() {
    //Sounder.play("tarararan")
    Main.that.sounder.play("tarararan")
    this.cornholio.setAnimation("stand");
    this.sorry.setAnimation("speak");
    jQuery(".js-message-sorry", this.mc).show();
    MainLoop.subscribe(this, "onMainLoop", MainLoop.PRIORITY_MAIN);
  }


  onMainLoop() {
    this.tick++;
    if (this.tick > 240) {
      MainLoop.unsubscribe(this);
      jQuery(".js-message-qbert", this.mc).show();
      //this.cornholio.setAnimation("run");
      this.sorry.setAnimation("stand");
      jQuery(".js-message-sorry", this.mc).hide();
      setTimeout(this.doExit.bind(this), 1000);
      Main.that.sounder.play("qbert");
      //TweenMax.to(jQuery(".js-cornholiio", this.mc), 3, { left: "100%", onComplete: this.endScenette.bind(this, true), ease: Linear.easeNone });
    }

  }

  doExit() {
    jQuery(".js-message-qbert", this.mc).hide();
    this.cornholio.setAnimation("run");
    TweenMax.to(jQuery(".js-cornholiio", this.mc), 3, { left: "100%", onComplete: this.endScenette.bind(this, true), ease: Linear.easeNone });
  }

  endScenette(won) {
    this.dispatch({ type: ScreenGameOver.EVENT_ENDED, won: won });
  }


  createCornholio(idanim) {
    let div = jQuery(".js-cornholiio", this.mc);
    let anim = JSON.parse(JSON.stringify(ScreenGameOver.CORNHOLIO));
    let spran = new Spran(div, anim, this.cornholioEventHandlers.bind(this));
    spran.init();
    spran.setAnimation(idanim);
    MainLoop.subscribe(spran)
    this.cornholio = spran;
    div.css("left", "-10%");


  }
  cornholioEventHandlers(e) {

  }


  createSorry() {
    let div = jQuery(".js-sorry", this.mc);
    let anim = JSON.parse(JSON.stringify(ScreenGameOver.SORRY));
    let spran = new Spran(div, anim, this.sorryEventHandlers.bind(this));
    spran.init();
    spran.setAnimation("stand");
    MainLoop.subscribe(spran)
    this.sorry = spran;
  }

  sorryEventHandlers() {

  }


  createScenetteOk() {
    //Sounder.play("ending")
    Main.that.sounder.play("ending")
    let sp;
    sp = Sprites.getSpriteByRowCol("floor", 0, 0);
    jQuery(".js-floor", this.mc).css("background-image", "url('" + sp + "')");

    jQuery(".js-main").removeClass("blue");
    jQuery(".js-main").addClass("black");

    MainLoop.start();
    this.createCornholio("walk");
    this.createPrincess();
    this.createKarateka();
    this.createSorry();
    MainLoop.start();
    TweenMax.to(jQuery(".js-cornholiio", this.mc), 5, { left: "40%", onComplete: this.friendzoned.bind(this), ease: Linear.easeNone });
    TweenMax.to(jQuery(".js-karateka", this.mc), 3, { delay: 2, left: "78%", onComplete: this.zanZan.bind(this), ease: Linear.easeNone });
  }
  createPrincess() {
    let div = jQuery(".js-princess", this.mc);
    let anim = JSON.parse(JSON.stringify(ScreenGameOver.PRINCESS));
    let spran = new Spran(div, anim, this.princessEventHandlers.bind(this));
    spran.init();
    spran.setAnimation("stand");
    MainLoop.subscribe(spran)
    this.princess = spran;
  }

  princessEventHandlers(e) {
    /*if (e.type === Spran.EVENT_END_ANIMATION) {
      if (e.data.anim.id === "hug") {
        this.sorry.setAnimation("trollface");
      }
    }*/

  }

  createKarateka() {
    let div = jQuery(".js-karateka", this.mc);
    let anim = JSON.parse(JSON.stringify(ScreenGameOver.KARATEKA));
    let spran = new Spran(div, anim, this.karatekaEventHandlers.bind(this));
    spran.init();
    spran.setAnimation("run");
    MainLoop.subscribe(spran)
    div.css("left", "-15%");
    this.karateka = spran;

  }

  karatekaEventHandlers(e) {

  }


  friendzoned() {
    this.cornholio.setAnimation("stand");

    this.sorry.setAnimation("speak");
    jQuery(".js-message-end", this.mc).show();
    MainLoop.subscribe(this, "onMainLoop1", MainLoop.PRIORITY_MAIN);

  }

  onMainLoop1() {
    this.tick++;
    if (this.tick > 360) {
      MainLoop.unsubscribe(this);
      this.sorry.setAnimation("trollface");
      jQuery(".js-message-end", this.mc).hide();
      setTimeout(this.goBack.bind(this), 1500);


    }

  }

  goBack() {
    this.cornholio.setAnimation("runflipped");
    TweenMax.to(jQuery(".js-cornholiio", this.mc), 2, { left: "-10%", onComplete: this.endScenetteOk.bind(this), ease: Linear.easeNone });
  }


  zanZan() {
    this.karateka.pause();
    jQuery(".js-karateka", this.mc).hide();
    this.princess.setAnimation("hug");

  }


  endScenetteOk() {
    this.showStats();
  }

  showStats() {
    jQuery(".js-princess", this.mc).hide();
    jQuery(".js-sorry", this.mc).hide();
    jQuery(".js-message-stats", this.mc).show();
    jQuery(".js-bottom-stats", this.mc).show();

    let savegame = Main.savegame;
    let a = savegame.data;
    let run = 0;
    let deaths = 0;
    let spears = 0;
    for (let x = 0; x < a.length; x++) {
      run += a[x].run;
      deaths += a[x].deaths;
      spears += a[x].spears;
    }
    jQuery(".js-total-run", this.mc).text("" + run);
    jQuery(".js-total-death", this.mc).text("" + deaths);
    jQuery(".js-total-spears", this.mc).text("" + spears);
    jQuery(".js-total-curses", this.mc).text("" + Pqp.rnd(10000, 2345));
    this.mc.on("click", this.endScenette.bind(this, false));


  }



}
ScreenGameOver.EVENT_ENDED = "eventEnded";


ScreenGameOver.CORNHOLIO = [
  {
    id: "stand",
    sheet: "front",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 }
    ]
  },
  {
    id: "run",
    sheet: "front",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 },
      { row: 0, col: 1, time: 100 },
      { row: 0, col: 2, time: 100 },
    ]
  },
  {
    id: "runflipped",
    sheet: "front",
    flip: true,
    frames: [
      { row: 0, col: 0, time: 100 },
      { row: 0, col: 1, time: 100 },
      { row: 0, col: 2, time: 100 },
    ]
  },
  {
    id: "walk",
    sheet: "front",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 200 },
      { row: 0, col: 1, time: 200 },
      { row: 0, col: 2, time: 200 },
    ]
  },
]


ScreenGameOver.SORRY = [
  {
    id: "stand",
    sheet: "sorry",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 }
    ]
  },
  {
    id: "speak",
    sheet: "sorry",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 150 },
      { row: 0, col: 1, time: 150 },
    ]
  },
  {
    id: "trollface",
    sheet: "sorry",
    flip: false,
    frames: [
      { row: 0, col: 2, time: 150 }
    ]
  }
]

ScreenGameOver.PRINCESS = [
  {
    id: "stand",
    sheet: "girl",
    flip: false,
    frames: [
      { row: 0, col: 1, time: 1000 },
      { row: 0, col: 0, time: 100000 }
    ]
  },
  {
    id: "preparehug",
    sheet: "girl",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 }
    ]
  },
  {
    id: "hug",
    sheet: "girl",
    flip: false,
    frames: [
      { row: 0, col: 2, time: 200 },
      { row: 0, col: 3, time: 200 },
      { row: 0, col: 4, time: 500 },
      { row: 0, col: 5, time: 200 },
      { row: 0, col: 6, time: 1000 },
      { row: 0, col: 5, time: 200 },
      { row: 0, col: 4, time: 500 },
      { row: 0, col: 3, time: 200 },
      { row: 0, col: 2, time: 3000 },
    ]
  },
]

ScreenGameOver.KARATEKA = [
  {
    id: "run",
    sheet: "karateka",
    flip: false,
    frames: [
      { row: 0, col: 0, time: 100 },
      { row: 0, col: 1, time: 100 },
      { row: 0, col: 2, time: 100 },
      { row: 0, col: 3, time: 100 },
      { row: 0, col: 4, time: 100 },
      { row: 0, col: 5, time: 100 },
      { row: 0, col: 6, time: 100 },
      { row: 0, col: 7, time: 100 }
    ]
  },
]


